import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./JobCardFile.js";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput.js";
import { validate } from "../../custom/validations/Validate.js";
import { getRecords, saveRecords } from "../../services/api.service.js";
import { toast } from "react-toastify";
import { LoaderCreatePage } from "../Loader/Loader.js";
import { loaderOverlay } from "../../Style/loaderOverly.js";
import BasicPopupModel from "../../custom_components/Components/BasicPopupModel.js";
import Select from "react-select";
import CustomError from "../../custom/components/Errors/CustomError.js";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import NumberInput from "../../custom/components/Number-Input/NumberInput.js";
import MultiSelectInput from "../../custom/components/MultiSelect-Input/MultiSelectInput.js";

const JobCardCreate = ({
  action,
  setAction,
  jobCardData,
  loadingData,
  setLoadingData,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const [popup, setPopup] = useState(false);
  const [scrapReasonsOptions, setScrapReasonsOptions] = useState([]);
  const [selectedScrapReasons, setSelectedScrapReasons] = useState("");
  const [scrapReasonsError, setScrapReasonsError] = useState("");
  const initialPayload = useMemo(() => payload, []);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemSelectOptions, setItemSelectOptions] = useState([]);
  const [itemRows, setItemRows] = useState([
    {
      remark: "",
      material_id: null,
      gmds_code: "",
      available_quantity: "",
      quantity: "",
    },
  ]);
  const [itemRowErrors, setItemRowErrors] = useState([]);
  const [faultReasonSelect, setFaultReasonSelect] = useState(null);
  const [faultReasonSelectOptions, setFaultReasonSelectOptions] = useState([
    { value: "all", label: "Select All" },
  ]);
  useEffect(() => {
    if (action === "Reject") {
      getScrapReasonsData();
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ["technician_check_is_repairable"]: false,
        },
      }));
    } else if (action === "Approve") {
      geMaterialsData();
      getFaultReasonData();
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ["technician_check_is_repairable"]: true,
        },
      }));
    }
  }, [action, jobCardData]);

  const geMaterialsData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "material_masters",
        schema: initialPayload?.schema,
        whereCondition: {
          is_active: true,
        },
        include: [
          {
            model: "category_masters",
            as: "category",
            where: {
              type: 1,
            },
            required: true,
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");
      // the dropdown is an Item Description picker - the label is strictly the
      // item master descriptions, GMDS code is auto-populated from the selection
      const newArray = (responseData.data || [])
        .map((item) => ({
          value: item.id,
          label: item.descriptions || "",
          gmds_code: item.gmds_code || "",
        }))
        .sort((a, b) => String(a.label).localeCompare(String(b.label)));
      setItemSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const getFaultReasonData = async () => {
    const schema = localStorage.getItem("schema");

    try {
      let payload = {
        modelName: "fault_reason_masters",
        schema: schema,
        whereCondition: { is_active: true },
      };

      const response = await getRecords(payload, "/getRecords");

      if (response && response.code === 1 && Array.isArray(response.data)) {
        const itemOptions = response.data.map((item) => ({
          value: item.id,
          label: `${item.reason}`,
        }));

        setFaultReasonSelectOptions([
          { value: "all", label: "Select All" },
          ...itemOptions,
        ]);
      } else {
        console.error("Unexpected response format:", response);
        setFaultReasonSelectOptions([{ value: "all", label: "Select All" }]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setFaultReasonSelectOptions([{ value: "all", label: "Select All" }]);
    }
  };
  const handleFaultReasonSelect = (selectedOptions) => {
    let finalOptions = [];

    if (selectedOptions && selectedOptions.length > 0) {
      const allOption = selectedOptions.find((opt) => opt.value === "all");
      finalOptions = allOption
        ? faultReasonSelectOptions.filter((opt) => opt.value !== "all")
        : selectedOptions;
    }

    const selectedIds = finalOptions.map((opt) => opt.value);

    // 🔹 validate like single select
    const fieldError = validate(validationType, {
      fault_reason_ids: selectedIds,
    });

    setFaultReasonSelect(finalOptions);

    setFormErrors((prev) => ({
      ...prev,
      fault_reason_ids: fieldError?.fault_reason_ids || "",
    }));

    setFormData((prev) => ({
      ...prev,
      inputData: {
        ...prev.inputData,
        fault_reason_ids: selectedIds,
      },
    }));
  };

  const handleItemSelect = async (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      material_id: selectedValue,
    });

    setSelectedItem(options);
    setFormErrors((prevformErrors) => ({
      ...prevformErrors,
      material_id: fieldError?.material_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        material_id: selectedValue,
      },
    }));
  };
  const getScrapReasonsData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "scrap_reason_masters",
        whereCondition: {
          is_active: true,
        },
        schema: initialPayload?.schema,
      };

      const responseData = await getRecords(payload, "/getRecords");
      let newArray = [
        ...(responseData.data?.map((item) => ({
          value: item.id,
          label: item.reason,
        })) || []),
        { value: 0, label: "Other" },
      ];

      setScrapReasonsOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleScrapReasonsSelect = (options) => {
    const selectedValue = options ? options.value : "";

    setSelectedScrapReasons(options);

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        scrap_reason_id: selectedValue,
      },
    }));

    setScrapReasonsError("");
  };

  const fetchAvailableQtyForRow = async (index, materialId) => {
    try {
      const payload = {
        technician_id: jobCardData?.technician_id,
        material_id: materialId,
      };

      const response = await getRecords(payload, "/materials/available-qty");

      const availableQty = response?.data?.available_qty ?? 0;

      setItemRows((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          material_id: materialId,
          available_quantity: availableQty,
          quantity: "",
        };
        return updated;
      });

      setItemRowErrors((prevErrors) => {
        const updatedErrors = [...prevErrors];

        if (updatedErrors[index]) {
          delete updatedErrors[index].quantity;
        }

        return updatedErrors;
      });
    } catch (error) {
      console.error("Failed to fetch available quantity", error);
    }
  };

  // const onInputChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   setFormErrors((prevErrors) => {
  //     const fieldError = validate(validationType, { [name]: value });
  //     return {
  //       ...prevErrors,
  //       [name]: fieldError[name] || null,
  //     };
  //   });

  //   setFormData((prevState) => ({
  //     ...prevState,
  //     inputData: {
  //       ...prevState.inputData,
  //       [name]:
  //         type === "checkbox"
  //           ? checked === true
  //             ? 1
  //             : 0
  //           : name === "alt_mobile_number" && value === ""
  //             ? null
  //             : value,
  //     },
  //   }));

  //   if (name === "technician_check_is_repairable") {
  //     if (checked) setAction("Approve");
  //     else setAction("Reject");
  //   }
  // };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // 🔥 SPECIAL HANDLING FOR REPAIRABLE TOGGLE
    if (name === "technician_check_is_repairable") {
      const isRepairable = checked;

      // Reset everything
      setFormData(basicFormData()); // reset whole form
      setFormErrors({});
      setItemRowErrors([]);
      setSelectedItem(null);
      setFaultReasonSelect(null);
      setSelectedScrapReasons("");
      setScrapReasonsError("");
      setItemRows([
        {
          remark: "",
          material_id: null,
          gmds_code: "",
          available_quantity: "",
          quantity: "",
        },
      ]);

      // Set repairable value properly
      setFormData((prev) => ({
        ...basicFormData(),
        inputData: {
          ...basicFormData().inputData,
          technician_check_is_repairable: isRepairable ? 1 : 0,
        },
      }));

      setAction(isRepairable ? "Approve" : "Reject");
      return; // ⛔ stop further execution
    }

    // ✅ Normal fields
    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };
  const validateAllRows = () => {
    const errors = itemRows.map((row) => validateRow(row));
    setItemRowErrors(errors);

    return errors.every((err) => Object.keys(err).length === 0);
  };

  const handleValidation = () => {
    let validationErrors = validate(validationType, formData.inputData);
    const isRepairable = formData?.inputData?.technician_check_is_repairable;

    let hasError = false;

    if (isRepairable) {
      delete validationErrors.scrap_reason_id;
      delete validationErrors.other_scrap_reason;

      const hasAnyItem = itemRows.some(
        (row) => row.material_id || row.quantity || row.remark,
      );

      if (hasAnyItem) {
        const rowsValid = validateAllRows();
        if (!rowsValid) {
          hasError = true;
        }
      } else {
        setItemRowErrors([]);
      }
    } else {
      delete validationErrors.fault_reason_ids;
      delete validationErrors.component_reference_no_1;
      delete validationErrors.component_reference_no_2;
      delete validationErrors.component_reference_no_3;
      delete validationErrors.component_reference_no_4;
      delete validationErrors.component_reference_no_5;

      setItemRowErrors([]);

      if (!selectedScrapReasons) {
        setScrapReasonsError("Scrap Reason is required");
        hasError = true;
      } else {
        setScrapReasonsError("");
      }

      if (selectedScrapReasons?.value !== 0) {
        delete validationErrors.other_scrap_reason;
      }

      if (selectedScrapReasons?.value === 0) {
        delete validationErrors.scrap_reason_id;
      }
    }

    setFormErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      hasError = true;
    }

    if (hasError) {
      return;
    }

    setPopup(true);
  };
  const addRow = () => {
    setItemRows((prev) => [
      ...prev,
      {
        remark: "",
        material_id: null,
        gmds_code: "",
        available_quantity: "",
        quantity: "",
      },
    ]);
  };

  const removeRow = (index) => {
    setItemRows((prevRows) => {
      return prevRows.filter((_, i) => i !== index);
    });

    setItemRowErrors((prevErrors) => {
      if (prevErrors.length === 1) {
        return [];
      }

      return prevErrors.filter((_, i) => i !== index);
    });
  };

  const validateRowField = (row, field) => {
    if (field === "remark") {
      if (!row.remark?.trim()) {
        return "Remark cannot be blank.";
      }
    }

    if (field === "material_id") {
      if (!row.material_id) {
        return "Item Description cannot be blank.";
      }
    }

    if (field === "quantity") {
      if (!row.quantity) {
        return "Quantity cannot be blank.";
      }
      if (Number(row.quantity) > Number(row.available_quantity || 0)) {
        return "Quantity must be less than or equal to available quantity.";
      }
    }

    return null; // ✅ no error
  };

  const handleRowChange = (index, field, value) => {
    setItemRows((prevRows) => {
      const updatedRows = [...prevRows];
      updatedRows[index] = {
        ...updatedRows[index],
        [field]: value,
      };

      // ✅ validate ONLY this field for this row
      setItemRowErrors((prevErrors) => {
        const updatedErrors = [...prevErrors];
        const fieldError = validateRowField(updatedRows[index], field);

        updatedErrors[index] = {
          ...(updatedErrors[index] || {}),
          [field]: fieldError,
        };

        // remove error key if valid
        if (!fieldError) {
          delete updatedErrors[index][field];
        }

        return updatedErrors;
      });

      return updatedRows;
    });
  };

  const validateRow = (row) => {
    const errors = {};

    if (!row.remark?.trim()) {
      errors.remark = "Remark cannot be blank";
    }

    if (!row.material_id) {
      errors.material_id = "Item Description cannot be blank.";
    }

    if (!row.quantity) {
      errors.quantity = "Quantity cannot be blank";
    } else if (Number(row.quantity) > Number(row.available_quantity || 0)) {
      errors.quantity =
        "Quantity must be less than or equal to available quantity";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      const baseInputData = {
        technician_id: jobCardData?.technician?.id,
        technician_check_at: formData.inputData.technician_check_at,
        intake_id: jobCardData?.intake_id,
        updated_by: userDetails?.id,
      };
      const itemsPayload = itemRows
        .filter((row) => row.material_id)
        .map((row) => ({
          material_id: row.material_id,
          required_qty: Number(row.quantity),
          available_qty: Number(row.available_quantity),
          remark: row.remark,
        }));

      const payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        useTransaction: true,
        relation: [
          {
            moduleAs: "spare_items",

            modelName: "job_card_spare_lists",

            foreignKey: "job_card_id",
          },
        ],
        id,
        inputData: formData.inputData.technician_check_is_repairable
          ? {
              ...baseInputData,
              technician_check_is_repairable: true,
              technician_check_remark:
                formData?.inputData?.technician_check_remark,
              component_reference_no_1:
                formData.inputData.component_reference_no_1,
              component_reference_no_2:
                formData.inputData.component_reference_no_2,
              component_reference_no_3:
                formData.inputData.component_reference_no_3,
              component_reference_no_4:
                formData.inputData.component_reference_no_4,
              component_reference_no_5:
                formData.inputData.component_reference_no_5,
              fault_reason_ids: formData.inputData.fault_reason_ids,
              spare_items: itemsPayload,
            }
          : {
              ...baseInputData,
              technician_check_is_repairable: false,
              scrap_reason_id: formData.inputData.scrap_reason_id,
              technician_check_remark:
                formData.inputData.technician_check_remark,
              technician_custom_reason: formData.inputData.other_scrap_reason,
            },
      };
      // console.log("payload", payload);
      // return;

      const responseData = await saveRecords(payload, createEndpoint);

      if (responseData?.code === 1) {
        toast.success(`${headerName} updated successfully!`);
        setPopup(false);

        navigate(action === "Approve" ? navigatePage?.back : "/scrap-list");
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`,
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };
  const selectedItems = itemRows.map((row) => row.material_id);

  return (
    <div className="card">
      {/* <p className="text-muted pb-1">
        Fields marked with <span className="text-danger fw-bold">*</span>{" "}
        are required.
      </p> */}
      <form className="card-body">
        <Row className="mt-1">
          <Col lg="12">
            <CheckboxInput
              name="technician_check_is_repairable"
              label="Is Repairable"
              value={formData?.inputData?.technician_check_is_repairable}
              checked={formData?.inputData?.technician_check_is_repairable}
              handleTextChange={onInputChange}
              parentClassName="form-check"
              checkBoxClassName="form-check-input"
              labelClassName="form-check-label"
            />
          </Col>
          {formData?.inputData?.technician_check_is_repairable && (
            <Row className="mt-2">
              <Col md="6" className="mt-3">
                <MultiSelectInput
                  label="Fault Reason"
                  value={faultReasonSelect}
                  options={faultReasonSelectOptions}
                  onMultiSelect={(selected) =>
                    handleFaultReasonSelect(selected)
                  }
                  placeholder="Select Fault reason"
                  labelClassName="form-label"
                  isClearable={true}
                  asterisk={true}
                  customError={formErrors.fault_reason_ids}
                />
              </Col>
              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Component Reference No. 1"
                  name="component_reference_no_1"
                  value={formData?.inputData?.component_reference_no_1}
                  onChange={onInputChange}
                  placeholder="Enter Component Reference No. 1"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.component_reference_no_1}
                />
              </Col>

              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Component Reference No. 2"
                  name="component_reference_no_2"
                  value={formData?.inputData?.component_reference_no_2}
                  onChange={onInputChange}
                  placeholder="Enter Component Reference No. 2"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.component_reference_no_2}
                />
              </Col>

              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Component Reference No. 3"
                  name="component_reference_no_3"
                  value={formData?.inputData?.component_reference_no_3}
                  onChange={onInputChange}
                  placeholder="Enter Component Reference No. 3"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.component_reference_no_3}
                />
              </Col>

              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Component Reference No. 4"
                  name="component_reference_no_4"
                  value={formData?.inputData?.component_reference_no_4}
                  onChange={onInputChange}
                  placeholder="Enter Component Reference No. 4"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.component_reference_no_4}
                />
              </Col>

              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Component Reference No. 5"
                  name="component_reference_no_5"
                  value={formData?.inputData?.component_reference_no_5}
                  onChange={onInputChange}
                  placeholder="Enter Component Reference No. 5"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.component_reference_no_5}
                />
              </Col>
              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Remark"
                  name="technician_check_remark"
                  value={formData?.inputData?.technician_check_remark}
                  onChange={onInputChange}
                  placeholder="Remark"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.technician_check_remark}
                />
              </Col>
            </Row>
          )}
          {formData?.inputData?.technician_check_is_repairable ? (
            // <>
            //   <Col md="6" className="mt-3">
            //     <TextAreaInput
            //       label="Remark"
            //       name="technician_check_remark"
            //       value={formData?.inputData?.technician_check_remark}
            //       onChange={onInputChange}
            //       placeholder="Check Remark"
            //       inputClassName="form-control"
            //       labelClassName="form-label"
            //       asterisk={true}
            //       customError={formErrors?.technician_check_remark}
            //     />
            //   </Col>
            //   <Col md="6" className="mt-3">
            //     <SelectInput
            //       label="Select Item"
            //       options={itemSelectOptions}
            //       value={selectedItem}
            //       onSelect={handleItemSelect}
            //       placeholder="Select Item"
            //       inputClassName="form-control"
            //       labelClassName="form-label"
            //       asterisk={true}
            //       customError={formErrors?.material_id}
            //     />
            //   </Col>
            //   <Col md="6" className="mt-3">
            //     <TextInput
            //       label="Available Quantity"
            //       name="available_quantity"
            //       value={formData?.inputData?.available_quantity}
            //       placeholder="Available Quantity"
            //       inputClassName="form-control"
            //       labelClassName="form-label"
            //       asterisk={true}
            //       customError={formErrors?.available_quantity}
            //       disabled={true}
            //     />
            //   </Col>

            //   <Col md="6" className="mt-3">
            //     <NumberInput
            //       label="Require Quantity"
            //       name="quantity"
            //       value={formData?.inputData?.quantity}
            //       onChange={onInputChange}
            //       placeholder="Require Quantity"
            //       inputClassName="form-control"
            //       labelClassName="form-label"
            //       asterisk={true}
            //       customError={formErrors?.quantity}
            //     />
            //   </Col>
            // </>

            <div className="card mt-4">
              <Row className="mt-4">
                <Col
                  style={{
                    marginLeft: "",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h6
                    className="h-6-heading"
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#333",
                      backgroundColor: "#f8f9fa",
                      padding: "5px 20px",
                      paddingTop: "10px",
                      borderRadius: "8px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      display: "inline-block",
                      margin: "0",
                    }}
                  >
                    Item Details
                  </h6>
                  <Button
                    color="primary"
                    className="waves-effect waves-light me-1 "
                    onClick={addRow}
                    style={{ background: "#006eb9" }}
                  >
                    Add
                  </Button>
                </Col>

                <div
                  className="table mt-2"
                  style={{
                    maxHeight: "450px",
                    overflowY: "auto",
                    width: "100%",
                    scrollBehavior: "smooth",
                  }}
                >
                  <table className="table table-hover">
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "#f9992d",
                        zIndex: 1,
                      }}
                    >
                      <tr>
                        <th>Sr. No</th>
                        <th>Item Description</th>
                        <th>GMDS Code</th>
                        <th>Available Quantity</th>
                        <th>Require Quantity</th>
                        <th>Remark</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {itemRows.map((row, index) => (
                        <tr key={index}>
                          <td className="mt-2">{index + 1}</td>

                          <td style={{ minWidth: 200 }}>
                            <SelectInput
                              label=""
                              options={itemSelectOptions.filter(
                                (option) =>
                                  !selectedItems.includes(option.value),
                              )}
                              value={itemSelectOptions.find(
                                (opt) => opt.value === row.material_id,
                              )}
                              labelStyle={{ display: "none" }}
                              onSelect={(opt) => {
                                const materialId = opt?.value;

                                handleRowChange(
                                  index,
                                  "material_id",
                                  materialId,
                                );

                                // auto-populate the GMDS code of the
                                // selected item description
                                handleRowChange(
                                  index,
                                  "gmds_code",
                                  opt?.gmds_code || "",
                                );

                                if (materialId) {
                                  fetchAvailableQtyForRow(index, materialId);
                                }
                              }}
                              customError={itemRowErrors?.[index]?.material_id}
                              placeholder="Select Item Description"
                            />
                          </td>

                          <td style={{ minWidth: 200 }}>
                            <TextInput
                              label=""
                              value={row.gmds_code}
                              placeholder="GMDS Code"
                              labelStyle={{ display: "none" }}
                              disabled
                            />
                          </td>

                          <td>
                            <TextInput
                              label=""
                              value={row.available_quantity}
                              placeholder="Available Qty"
                              labelStyle={{ display: "none" }}
                              disabled
                            />
                          </td>

                          <td>
                            <NumberInput
                              label=""
                              value={row.quantity}
                              onChange={(e) =>
                                handleRowChange(
                                  index,
                                  "quantity",
                                  e.target.value,
                                )
                              }
                              labelStyle={{ display: "none" }}
                              placeholder="Require Quantity"
                              customError={itemRowErrors?.[index]?.quantity}
                            />
                          </td>
                          <td>
                            <TextInput
                              label=""
                              name="remark"
                              value={row.remark}
                              onChange={(e) =>
                                handleRowChange(index, "remark", e.target.value)
                              }
                              labelStyle={{ display: "none" }}
                              placeholder="Remark"
                              customError={itemRowErrors?.[index]?.remark}
                            />
                          </td>

                          {/* Delete */}
                          <td>
                            <div onClick={() => removeRow(index)}>
                              <Link className="text-danger">
                                <i className="mdi mdi-trash-can font-size-18"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Row>
            </div>
          ) : (
            <>
              {" "}
              <Col md="6" className="mt-3">
                <SelectInput
                  label="Select Scrap Reason"
                  options={scrapReasonsOptions}
                  value={selectedScrapReasons}
                  onSelect={handleScrapReasonsSelect}
                  placeholder="Select Scrap Reason"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  asterisk={true}
                  customError={scrapReasonsError}
                />
              </Col>
              {selectedScrapReasons?.value === 0 && (
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Other Scrap Reason"
                    name="other_scrap_reason"
                    value={formData?.inputData?.other_scrap_reason}
                    onChange={onInputChange}
                    placeholder="Other Scrap Reason"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    asterisk={true}
                    customError={formErrors?.other_scrap_reason}
                  />
                </Col>
              )}
              <Col md="6" className="mt-3">
                <TextAreaInput
                  label="Remark"
                  name="technician_check_remark"
                  value={formData?.inputData?.technician_check_remark}
                  onChange={onInputChange}
                  placeholder="Remark"
                  inputClassName="form-control"
                  labelClassName="form-label"
                  customError={formErrors?.technician_check_remark}
                />
              </Col>
            </>
          )}

          <Col lg="12" className="mt-3">
            <CheckboxInput
              name="is_active"
              label="Is Active"
              value={formData?.inputData?.is_active}
              checked={formData?.inputData?.is_active}
              handleTextChange={onInputChange}
              parentClassName="form-check"
              checkBoxClassName="form-check-input"
              labelClassName="form-check-label"
            />
          </Col>
        </Row>
        <div className="mt-3 d-flex gap-3 flex-wrap">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleValidation}
          >
            {action}
          </button>
          <button
            type="button"
            onClick={() => {
              setAction("None");
              navigate(navigatePage?.back);
            }}
            className="btn btn-secondary"
          >
            Cancel
          </button>
        </div>
      </form>

      <BasicPopupModel
        isVisible={popup}
        onClose={() => setPopup(false)}
        title={`Are you sure you want to ${action} this job card?`}
      >
        <div className="mt-3">
          <div className="text-center">
            <span>Job Card No: </span>{" "}
            <strong>{jobCardData?.job_card_no}</strong>
          </div>
          <div className="mt-3 d-flex gap-3 flex-wrap justify-content-center">
            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => {
                handleSubmit(e);
                setPopup(false);
              }}
            >
              {action}
            </button>
            <button
              type="button"
              onClick={() => {
                setPopup(false);
              }}
              className="btn btn-secondary"
            >
              Cancel
            </button>
          </div>
        </div>
      </BasicPopupModel>
    </div>
  );
};

export default JobCardCreate;
